// Mirror of `signupUnit*` in @tournament-suite/league-rules — the viewer builds with
// CRA and cannot compile the workspace package, so the rule lives here too.
// A doubles kolejka seats a whole pair on one signup, so its counts — seat limit,
// minimum turnout, waitlist — are counts of pairs; everywhere else they are people.

const DOUBLES_DISCIPLINES = ['DOUBLES', 'DOUBLES_M', 'DOUBLES_F', 'DOUBLES_W', 'DOUBLES_MIX', 'MIXED'];

export type SignupUnit = 'PAIR' | 'PLAYER';

export function signupUnitOf(discipline: string | null | undefined): SignupUnit {
  if (discipline != null && DOUBLES_DISCIPLINES.includes(discipline)) {
    return 'PAIR';
  }

  return 'PLAYER';
}

export function signupUnitCount(unit: SignupUnit, count: number): string {
  return `${count} ${countedNoun(unit, count)}`;
}

function countedNoun(unit: SignupUnit, count: number): string {
  const forms = unit === 'PAIR'
    ? { one: 'para', few: 'pary', many: 'par' }
    : { one: 'zawodnik', few: 'zawodnicy', many: 'zawodników' };

  if (count === 1) {
    return forms.one;
  }

  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) {
    return forms.few;
  }

  return forms.many;
}
